﻿<style scoped>
    .pagination {
        display: flex;
    }

    .pagination {
        display: inline-block;
        padding-left: 0;
        margin: 20px 0;
        border-radius: 4px;
    }
</style>
<template>
    <div class="admin-users">
        <p v-if="loading" role="status">Loading users…</p>
        <div v-else-if="error" role="alert">Unable to load users. <AppButton variant="basic"  @click="$store.dispatch('getUsers')">Try again</AppButton></div>
        <p v-else-if="!users.length">No users found.</p>
        <div v-else class="admin-table-scroll" tabindex="0" role="region" aria-label="Users"><table class="bs:w-full bs:border-collapse bs:bg-surface bs:rounded-sm">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Username</th>
                    <th>Email Address</th>
                    <th>Date Created</th>
                    <th>Last Login</th>
                    <th>Brews</th>
                    <th>Tilts</th><th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="user in users" :key="user.userId">
                    <td>{{ user.userId }}</td>
                    <td>{{ user.userName }}</td>
                    <td>{{ user.emailAddress }}</td>
                    <td>{{ formatDateOnly(user.dateCreated) }}</td>
                    <td class="collapsing">{{ fromNow(user.dateCreated) }}</td>
                    <td class="collapsing">{{ user.brews }} / {{ user.archivedBrews }}</td>
                    <td class="collapsing">{{ user.tilts }} / {{ user.archviedTilts }}</td>
                <td><a :href="'/admin/doasdleklasdfasd?hashKey=' + user.userId">Impersonate {{ user.userName }}</a></td>
                </tr>
            </tbody>
        </table></div>
        <!--<uib-pagination v-model="pagination" :total-items="totalUsers":max-size="5" class="pagination" :boundary-links="true"></uib-pagination>-->
        <paginate v-if="!loading && !error && totalPages > 1" :page="pagination.page" :pages="totalPages" @select="paginateClickCallback" />
    </div>
</template>
<script>
import AppButton from "../../components/ui/AppButton.vue";
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
    import Paginate from "../../components/Pagination.vue"

    export default {
        components: { AppButton,
            Paginate
        },
        created() {

        },
        mounted() {
            this.$store.dispatch("getUsers");
        },
        updated() {

        },
        computed: {
            ...mapState(["currentUser", "users", "totalUsers", "loading", "error", "pagination"]),
            ...mapGetters(["totalPages"])

        },
        methods: {
            paginateClickCallback(pageNum) {
                this.$store.dispatch("paginate", pageNum);
            }
        }
    };
</script>
<style scoped>
.admin-table-scroll { overflow-x: auto; max-width: 100%; margin-bottom: 1rem; border: 1px solid var(--bs-color-rule); }
th, td { text-align: left; padding: 10px; border-bottom: 1px solid var(--bs-color-rule); }
th { background: #f3f4f5; }
td { font-variant-numeric: tabular-nums; }
td a { display: inline-flex; align-items: center; min-height: 44px; }
@media (max-width: 767px) {
  table, thead, tbody, tr, th, td { display: block; width: 100%; box-sizing: border-box; }
  thead, tbody tr { padding: .75rem 0; }
  thead { border-bottom: 1px solid var(--bs-color-rule); }
  th, td { padding: .3rem .75rem; border: 0; overflow-wrap: anywhere; }
  th { background: transparent; }
}
</style>
